import React, {  useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import CustomerSettingSidebar from '../layouts/CustomerSettingSidebar'
// import Select from "react-select";

// import FeatherIcon from 'feather-icons-react';
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
// import { useFormik } from "formik";
import { useFormik, FormikProvider, FieldArray } from "formik";
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CustomerUsersAdd = () => {
  const customer_id = localStorage.getItem('customer_id');

  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  
  const [customermodules, setCustomermodules] = useState([]);
  
  useEffect(() => {
   
        axios.post("/customerportal/customer-modules",{}, {
          headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if(response.data.code === 200){
            let supplier_types = response.data.data.modules;
            let modulesList = supplier_types.map((ord, index) => ({
              label:  ord.name ,
              value: ord.id,
              key: `supplier-${index}`,
            }));
            setCustomermodules(modulesList);
        }else{
            console.log("API response is not an array");
          }
                  
        })
        .catch((error) => {
          console.log(error);
        });

}, []);

  const formik = useFormik({
    initialValues: {
      customer_id:customer_id,
      user_first_name: '',
      user_last_name: '',
      password: "",
      current_password: "",
      user_function: '',
      user_email: '',
      accesspages: []
    },
    enableReinitialize: true,
    onSubmit: (values, actions) => {
      axios
        .post("/customerportal/users/add", values, {
          headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          actions.setSubmitting(false);

          if (response.data.code === 200) {
            toast.success(response.data.message);
            actions.resetForm();
            setTimeout(() => {
              window.location.href = "/customerportal/users";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        }).catch((error) => {
          console.log(error);
          actions.setSubmitting(false);
        });
    },
  });

  const customHandleInput = (event) => {
    const Input_name = event.name;
    delete backendErrors[Input_name];
  };

  const toggleMobileMenu = () => {
    setMenu(!menu)
  }
  
console.log(customer_id);


  return (
    <div className={`main-wrapper customer-portal-main  ${menu ? 'slide-nav': ''}`}> 
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar /> 	<ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-6">
                <h3 className="page-title">Update Profile</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Update Profile</li>
                </ul>
              </div>
            </div>
          </div>
        
          <div className="row">
            <div className="col-xl-2 col-md-3">
              <CustomerSettingSidebar />
            </div>
            
            <div className="col-xl-10 col-md-9">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Add User</h5>
                </div>
                <div className="card-body">
                   <FormikProvider value={formik}>
                   <form action="#" onSubmit={formik.handleSubmit}>
                    
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>First Name</label>
                          <input
                            type="text"
                            name="user_first_name"
                            value={formik.values.user_first_name}
                            className="form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_first_name && (
                              <span className="form-error mt-1">
                                {backendErrors.user_first_name}
                              </span>
                            )}
                          </small>
                        </div>
                       
                        
                      </div>
                     
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Last Name</label>
                          <input
                            type="text"
                            value={formik.values.user_last_name}
                            name="user_last_name"
                            className="form-input form-control"
                             onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }} 
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_last_name && (
                              <span className="form-error mt-1">
                                {backendErrors.user_last_name}
                              </span>
                            )}
                          </small>
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                      <div className="form-group">
                          <label>Email</label>
                          <input
                            type="text"
                            value={formik.values.user_email}
                            name="user_email"
                            className= "form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_email && (
                              <span className="form-error mt-1">
                                {backendErrors.user_email}
                              </span>
                            )}
                          </small>
                        </div>
                      
                      </div>
                      <div className="col-md-6">
                          <div className="form-group">
                              <label>Password</label>
                              <input
                              type="text"
                              name="password"
                              value={formik.values.password}
                              className= "form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                              onBlur={formik.handleBlur}
                              />
                              <small>
                              {backendErrors?.password && (
                                  <span className="form-error mt-1">
                                  {backendErrors.password}
                                  </span>
                              )}
                              </small>
                          </div>
                      </div>
                      <div className="col-md-6">
                              <div className="form-group">
                              <label>Confirm Password</label>
                              <input
                              type="text"
                              name="password_confirmation"
                              value={formik.values.password_confirmation}
                              className= "form-input form-control"
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                              onBlur={formik.handleBlur}
                              />
                              <small>
                              {backendErrors?.password_confirmation  && (
                                  <span className="form-error mt-1">
                                      {backendErrors.password_confirmation}
                                  </span>
                                  )}
                              </small>
                          </div>
                      </div>
                      <div className="col-md-12">
                      <div className="form-group">
                          <label>Function</label>
                          <input
                            type="text"
                            value={formik.values.user_function}
                            name="user_function"
                            className= "form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_function && (
                              <span className="form-error mt-1">
                                {backendErrors.user_function}
                              </span>
                            )}
                          </small>
                        </div>
                      
                      </div>
                    </div>
                    
                        <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Add Modules
                              </h4>
                            </div>
                          </div>
                          <FieldArray
                            name="accesspages"
                            render={(arrayHelpers) => (
                              <div>
                                <button
                                  className="btn btn-primary mb-3"
                                  type="button"
                                  // onClick={handleShow}
                                  onClick={() =>
                                    arrayHelpers.push({
                                      module: "",
                                    })
                                  }
                                >
                                  +
                                </button>
                                <table className="table">
                                  <tbody>
                                    {formik.values.accesspages.map((friend, index) => (
                                      <tr key={index}>
                                        
                                        
                                        <td>
                                          <div className="form-group status">
                                            <label>Module</label><br/>
                                            
                                              <Select
                                                  name={`accesspages[${index}].module`}
                                                  options={customermodules}
                                                  value={customermodules .find(option => option.value == formik.values.accesspages[index].module) || null} // Ensure correct format
                                                  onChange={(selectedOption) => {
                                                    formik.setFieldValue(`accesspages[${index}].module`, selectedOption.value); // ✅ Store only value in Formik
                                                    customHandleInput({
                                                      target: {
                                                        name: `accesspages[${index}].module`,
                                                        value: selectedOption.value, // ✅ Ensure only value is passed
                                                      },
                                                    });
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  placeholder="Select" 
                                                />
                                          </div>
                                        </td>
                                        
                                        
                                      
                                        <td>
                                          <div className="form-group">
                                            <button
                                              className="btn btn-danger"
                                              style={{ marginTop: 65 }}
                                              type="button"
                                              onClick={() =>
                                                arrayHelpers.remove(index)
                                              }
                                            >
                                              -
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          />
                    <small>
                      
                      {backendErrors.status && (
                        <span className="form-error mt-1">
                          {backendErrors.status}
                        </span>
                      )}
                    </small>
                    <div className="text-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={formik.isSubmitting}
                      >
                        Add User
                      </button>
                    </div>
                  </form>
                   </FormikProvider>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>		
  );
}

export default CustomerUsersAdd;